import React from "react";
import {
  Box,
  Button,
  Checkbox,
  ListItem,
  ModalBody,
  ModalFooter,
  UnorderedList,
  Text,
} from "@chakra-ui/react";
import { ModalBox } from "../../components/ModalBox";
import { useFetchSubscribers } from "../../hooks/useFetchSubscribers";

export const AddNewSubscriber = ({
  user,
  userRole,
  isOpen,
  onClose,
  existingUsers = [],
  onAdd,
  isworking = false,
}) => {
  const { subscribers, selectSubscriber } = useFetchSubscribers(
    user,
    userRole === "Teacher"
  );

  return (
    <Box>
      <ModalBox
        isOpen={isOpen}
        onClose={onClose}
        title={userRole === "Teacher" ? "Add student" : "Add child"}
      >
        <ModalBody pb={6}>
          <UnorderedList style={{ margin: 0 }}>
            {React.Children.toArray(
              subscribers
                ?.filter((s) => !existingUsers?.includes(s.id))
                .map((user) => (
                  <ListItem
                    style={{
                      listStyle: "none",
                      padding: "10px",
                    }}
                  >
                    <Checkbox
                      isChecked={user.isChecked}
                      onChange={(e) =>
                        selectSubscriber(e.target.value, e.target.checked)
                      }
                      value={user.id}
                    >
                      {`${user.firstName} ${user.lastName}`}
                    </Checkbox>
                  </ListItem>
                ))
            )}
          </UnorderedList>
          {subscribers?.filter((s) => !existingUsers?.includes(s.id)).length ===
            0 && (
            <Text
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: '"Open Sans", sans-serif',
                color: "rgb(66, 71, 112)",
                textAlign: "center",
                padding: "20px",
              }}
            >
              {userRole === "Teacher"
                ? "No students to add"
                : "No childs to add"}
            </Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={() => onAdd(subscribers?.filter((s) => s.isChecked))}
            isLoading={isworking}
            loadingText="Adding"
            disabled={subscribers?.filter((s) => s.isChecked).length === 0}
          >
            Add
          </Button>
          {!isworking && <Button onClick={onClose}>Cancel</Button>}
        </ModalFooter>
      </ModalBox>
    </Box>
  );
};
